export enum ProductSipHeaderTag {
  NAME = '0261',
  VERSION = '0262',
  SORENSON_SIP_VERSION = '0263',
}
